import React from 'react'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {CTA} from 'common/styleguide/CTA'
import {centeredText} from 'lib/styleguide/base.scss'
import styles from './AppStoreCancelDialog.scss'
import img from './img.png'
import img2x from './img2x.png'
import img3x from './img3x.png'

export const APP_STORE_CANCEL_DIALOG = 'APP_STORE_CANCEL_DIALOG'

export class AppStoreCancelDialog extends React.PureComponent {
  render () {
    const {gotIt, onRequestClose} = this.props

    return (
      <ModalOverlay maxWidth='870px' onRequestClose={onRequestClose}>
        <div className={styles.appStoreCancelDialog}>
          <div className={styles.phoneImg}>
            <img src={img}
              srcSet={`${img} 1x, ${img2x} 2x, ${img3x} 3x`}
              alt='upgrade ios subscription'
              style={{ maxWidth: '90%' }} />
          </div>
          <div className={styles.instructions}>
            <div>
              <h2>Update Subscription</h2>
              <ol style={{ paddingInlineStart: '30px' }}>
                <li>Tap the <b>home button</b> to go to your list of apps.</li>
                <li>Go to <b>Settings</b> icon. (Settings for your iPhone, looks like a gear icon)</li>
                <li>Tap <b>iTunes & App Store</b></li>
                <li>Tap your <b>Apple ID</b>. It’s the line that has your e-mail address in it.</li>
                <li>When prompted, select <b>View Apple ID</b>, you may have to enter the password for your Apple ID.</li>
                <li>Now you are under the Account Settings page for your Apple ID.</li>
                <li>Select <b>Subscriptions >.</b></li>
                <li>If you have more than one subscription, select <b>Ride with GPS</b>.</li>
                <li>Tap <b>Cancel Subscription</b>.</li>
                <li>Done. Your subscription will not renew.</li>
              </ol>
              <CTA onClick={gotIt}>Got It!</CTA>
              <p className={centeredText}>
                <a onClick={onRequestClose}>Cancel</a>
              </p>
            </div>
          </div>
        </div>
      </ModalOverlay>
    )
  }
}
